import React, { useState } from 'react';
import { urlFoto } from '../api.js';

export const Wave = () => (
  <svg className="wave" viewBox="0 0 56 12">
    <path d="M0 6 Q 7 1,14 6 T 28 6 T 42 6 T 56 6" />
  </svg>
);

/**
 * Foto de un centro.
 *
 * En el artifact original las imágenes venían embebidas en base64 dentro del
 * propio fichero, que por eso pesaba 604 KB. Ahora llegan como URL desde el
 * backend. Mientras no haya almacenamiento de objetos configurado, esas URL
 * no resuelven, así que el hueco se queda como una superficie del color de
 * la marca en vez de como un icono de imagen rota.
 */
export function Foto({ url, cls, label }) {
  const [fallo, setFallo] = useState(false);
  return (
    <div className={cls || ''}>
      {url && !fallo
        ? <img src={urlFoto(url)} alt="" onError={() => setFallo(true)} />
        : <div className="foto-vacia" aria-hidden="true" />}
      {label ? <div className="plabel">{label}</div> : null}
    </div>
  );
}

export function Cargando({ que = 'los centros' }) {
  return <div className="slots-empty">Cargando {que}…</div>;
}

export function ErrorCarga({ error, reintentar }) {
  return (
    <div className="slots-empty">
      {error?.message || 'No hemos podido cargar la información.'}
      {reintentar ? (
        <><br /><button className="btn ghost" style={{ marginTop: 14 }} onClick={reintentar}>
          Reintentar
        </button></>
      ) : null}
    </div>
  );
}
